import * as _ from 'underscore';
import * as marietta from '../..';
import { ITEM_MODE_NO } from '../Constants';

class WebcadXMLParser {
  /**
      * 読込みデータの生成
      * @myXML XML 読み込みデータ
      */
  static reproduceWebCAD(myXML: any, reverse: Boolean = false, isSaveHistory: Boolean = false, deferredObj:Function = null): void {
    marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects = true;

    if (myXML === null || myXML === '') return;

    // BUSY表示
    marietta.webcad.WebCADGlobal.showBusy('Loading...');

    // プランの読込
    const p = new Promise((resolve: Function) => {
      setTimeout(marietta.webcad.util.WebcadXMLParser.parse, 300, myXML, reverse, resolve, isSaveHistory);
    });

    // アイテム生成完了後にヒストリに保管
    p.then(() => {
      // 開いた UB の高さは変えず、今の状態を UB の天井合わせの基準にする
      marietta.webcad.util.UnitBathUtil.resetBaseline();
      if (!isSaveHistory) {
        marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
      }
      marietta.webcad.WebCADGlobal.webcad2Dmanager.isChanged = true;
      // 選択モードへ変更
      document.getElementById('checkSelectMode').click();
      marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects = false;
      marietta.webcad.WebCADGlobal.cadAPIManager.MakeRoomWall();
      marietta.webcad.WebCADGlobal.updateMeasureLine(false, false);

      // UNODO・REDOの場合は階数を変更しない
      if (isSaveHistory !== true) {
        // フロア表示の初期化処理
        marietta.webcad.WebCADGlobal.changeFloor(1);
      }

      // UNDO・REDOは下絵の位置を更新する
      if (isSaveHistory) {
        marietta.webcad.WebCADGlobal.webcad2Dmanager.updateShitaePositionToHistory();
      }

      // deferredObjを返す
      if (deferredObj) {
        deferredObj();
        // return deferredObj;
      }
    });
  }

  /**
     * パースする
     * */
  static parse(datXML: Element, reverse: Boolean = false, deferredObj = null, isSaveHistory: Boolean = false) {
    // 20181229 historyから復元している場合は、敷地の保持は実施しない
    let siteInputMode = 0;
    if (!isSaveHistory) {
      const tarLayer: marietta.webcad.layer.SiteLayer = marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(1, ITEM_MODE_NO.MODE_SITE_NO);
      siteInputMode = tarLayer.mode;

      // レイヤー削除前にアイテムを保管
      marietta.webcad.util.WebcadXMLParser.keepSiteItem();
    }

    // レイヤー全体の初期化
    marietta.webcad.WebCADGlobal.layerGroup.initMe();

    // 読込プランのバージョン
    if ((datXML).querySelector('application').querySelector('version') != null) {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.currentPlaneVersion = (datXML).querySelector('application').querySelector('version').textContent;
    }

    // 寸法補正（0:フリー寸法 / 1:モジュール補正）を先に確定する。欠落時は既定（フリー寸法）を維持（後方互換）。
    // ※buildingType setter が createPitchList を呼び寸法モードに応じてUI/スナップを設定するため、先に適用しておく。
    marietta.webcad.WebCADGlobal.moduleManager.applyDimensionCorrection(parseInt((datXML).querySelector('plan').getAttribute('dimension_correction'), 10));

    // モジュール
    if ((datXML).querySelector('plan').getAttribute('module') != null) {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.modulePitch = parseInt((datXML).querySelector('plan').getAttribute('module'), 10);
      // モジュール補正選択時に適用するピッチ（アプリ由来値）も保存値で復元しておく
      marietta.webcad.WebCADGlobal.moduleManager.modulePitchFromApp = marietta.webcad.WebCADGlobal.webcad2Dmanager.modulePitch;

      if (!Number.isNaN(parseFloat((datXML).querySelector('plan').getAttribute('grid')))) {
        marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnit = parseFloat((datXML).querySelector('plan').getAttribute('grid'));
      }
    }

    if ((datXML).querySelector('plan').getAttribute('building_type') != null) {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType = parseInt((datXML).querySelector('plan').getAttribute('building_type'), 10);
    } else {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType = 0;
    }

    // 最終的な寸法モードに合わせてモジュールUI（コンボボックス表示・スナップ欄）を同期する
    marietta.webcad.WebCADGlobal.webcad2Dmanager.refreshModuleUiForMode();

    // 3Dモデル用パラメータの判別と登録処理
    if ((datXML).querySelector('model_param')) {
      marietta.webcad.util.WebcadXMLParser.parseModelParam((datXML).querySelector('model_param'));
    } else {
      // 値を持っていなければ初期化
      marietta.webcad.WebCADGlobal.webcad2Dmanager.modelParam = null;
    }

    // 敷地
    marietta.webcad.util.WebcadXMLParser.reproduceSiteItem(datXML.querySelector('plan > site'));
    // 部屋
    marietta.webcad.util.WebcadXMLParser.reproduceRoomItem((datXML).querySelector('plan > room'), reverse);
    // 階段
    marietta.webcad.util.WebcadXMLParser.reproduceStairItem((datXML).querySelector('plan > stair'), reverse);
    // 建具
    marietta.webcad.util.WebcadXMLParser.reproduceMonicaItem((datXML).querySelector('plan > fitting'), 'fitting', reverse);
    // 住宅設備
    marietta.webcad.util.WebcadXMLParser.reproduceMonicaItem((datXML).querySelector('plan > equipment'), 'equipment', reverse);
    // 家具
    marietta.webcad.util.WebcadXMLParser.reproduceMonicaItem((datXML).querySelector('plan > furniture'), 'furniture', reverse);
    // エクステリア
    marietta.webcad.util.WebcadXMLParser.reproduceMonicaItem((datXML).querySelector('plan > exterior'), 'exterior', reverse);
    // 屋根
    marietta.webcad.util.WebcadXMLParser.reproduceRoofItem((datXML).querySelector('plan > roof'));

    // undo/redo以外はFit実行
    if (!isSaveHistory) {
      // 中央に移動
      marietta.webcad.WebCADGlobal.scrollerManager.controlLayerEnlargementFit();
    }

    // 20181229 historyから復元している場合は、敷地の保持は実施しない
    if (!isSaveHistory) {
      // 敷地があった場合は表示させる
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.siteList != null) {
        marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteInputMode = siteInputMode;
        marietta.webcad.WebCADGlobal.webcad2Dmanager.siteList.forEach((item) => {
          marietta.webcad.WebCADGlobal.itemManager.createItem(item);
        });
      }
    }

    // アクションモードの設定
    marietta.webcad.WebCADGlobal.webcad2Dmanager.updatecurrentActionModeFromItemMenu();

    // 階数の更新
    marietta.webcad.WebCADGlobal.webcad2Dmanager.updateFloorSelection();

    // 保持している下絵があれば、再生成
    marietta.webcad.util.WebcadXMLParser.resetShitae();

    // BUSY表示
    setTimeout(marietta.webcad.WebCADGlobal.hideBusy, 300);

    if (deferredObj) deferredObj();
  }

  /**
     * 敷地面積を確保する関数
     */
  static keepSiteItem() {
    // レイヤーを保持
    const list: marietta.webcad.item.MonicaObject[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_SITE_NO);
    const infoList: any = [];
    if (list.length > 0) {
      list.forEach((item) => {
        infoList.push(item.itemInfo);
      });
    }

    if (infoList.length > 0) {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.siteList = infoList;
    }
  }

  /**
     * 敷地
     * */
  static reproduceSiteItem(itemXML:Element) {
    if (itemXML === null) { return; }

    // モード
    let siteMode: number = parseInt(itemXML.getAttribute('mode'), 10);
    // TODO: LayerGroup.tsにgetTypeLayerInFloorLayer()を追加
    const itemLayer: marietta.webcad.layer.SiteLayer = marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(1, ITEM_MODE_NO.MODE_SITE_NO);
    if (Number.isNaN(siteMode as number)) { siteMode = 0; } // 指定されていない場合は簡易モード
    // TODO: itemLayerが取得できたらコメントアウト解除
    itemLayer.mode = siteMode;
    marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteInputMode = siteMode;

    // 方位
    marietta.webcad.WebCADGlobal.siteCompass.rotate(parseInt(itemXML.getAttribute('direction'), 10));

    // オブジェクト構造に変更
    const shapeList = itemXML.querySelectorAll('shape');
    let itemList = [];
    let itemInfoList: marietta.webcad.collection.ItemInfoCollection;
    for (let i = 0, len = shapeList.length; i < len; i += 1) {
      itemInfoList = new marietta.webcad.collection.ItemInfoCollection();
      itemInfoList.index = parseInt(shapeList[i].getAttribute('index'), 10);
      itemInfoList.id = 'sit01_01';
      itemInfoList.guid = shapeList[i].getAttribute('guid');
      //TODO:create new guid if none

      itemInfoList.floor = 1;
      itemInfoList.color = marietta.webcad.util.WebCADUtil.convertNum10To16(parseInt(shapeList[i].getAttribute('color'), 10));
      const pointList = (shapeList[i]).querySelectorAll('point');
      if (shapeList[i].hasAttribute('base')) {
        itemInfoList.baseNo = parseInt(shapeList[i].getAttribute('base'), 10);
      }
      let pointObj: marietta.webcad.collection.PointCollection;
      itemInfoList.dotList = [];
      for (let j = 0, len2 = pointList.length; j < len2; j += 1) {
        pointObj = new marietta.webcad.collection.PointCollection();
        pointObj.x = parseFloat(pointList[j].getAttribute('x'));
        pointObj.y = marietta.webcad.WebCADGlobal.LAYER_SIZE_H - parseFloat(pointList[j].getAttribute('y'));
        pointObj.road_w = parseInt(pointList[j].getAttribute('road_w'), 10);
        if (Number.isNaN(pointObj.road_w)) pointObj.road_w = 0;
        pointObj.road_lr = Boolean(parseInt(pointList[j].getAttribute('road_lr'), 10));
        pointObj.guid = pointList[j].getAttribute('guid');
        //TODO:create new guid if none

        itemInfoList.dotList.push(pointObj);
      }

      // TODO: convertToAllItems確認用、あとで消す
      itemInfoList.x = 0;
      itemInfoList.y = 0;
      itemList.push(itemInfoList);
    }

    // 順番の入れ替え
    itemList = _.sortBy(itemList, (obj) => obj.index);

    // 生成
    for (let k = 0, len3 = itemList.length; k < len3; k += 1) {
      marietta.webcad.WebCADGlobal.itemManager.createItem(itemList[k]);
    }
  }

  /**
     * 部屋
     * */
  static reproduceRoomItem(itemXML:Element, reverseBoo: Boolean = false) {
    if (itemXML === null) { return; }

    // オブジェクト構造に変更
    const itemIndexList = itemXML.querySelectorAll('item');
    let itemList = [];
    let itemInfoList: marietta.webcad.collection.ItemInfoCollection;
    for (let i = 0, len = itemIndexList.length; i < len; i += 1) {
      // //rom16(階段)は無視する
      // if(itemIndexList[i].getAttribute('id').indexOf('rom16') > -1) continue;

      itemInfoList = new marietta.webcad.collection.ItemInfoCollection();
      itemInfoList.index = parseInt(itemIndexList[i].getAttribute('index'), 10);
      itemInfoList.id = itemIndexList[i].getAttribute('id');
      itemInfoList.floor = parseInt(itemIndexList[i].getAttribute('f'), 10);
      itemInfoList.guid = itemIndexList[i].getAttribute('guid');
      //TODO:create guid if none

      const itemColor = parseInt(itemIndexList[i].getAttribute('color'), 10);
      if (!Number.isNaN(itemColor)) {
        itemInfoList.color = marietta.webcad.util.WebCADUtil.convertNum10To16(itemColor);
      }
      const itemDesignColor = parseInt(itemIndexList[i].getAttribute('design_color'), 10);
      if (!Number.isNaN(itemDesignColor)) {
        itemInfoList.designColor = marietta.webcad.util.WebCADUtil.convertNum10To16(itemDesignColor);
      }
      // TODO: xmlのdesign_typeとテクスチャのIDが一致していないので、統一する
      const itemDesignType = itemIndexList[i].getAttribute('design_type');
      if (itemDesignType !== null && itemDesignType !== '') {
        const newDesign = marietta.webcad.WebCADGlobal.convertToNewPattern(itemDesignType);
        if (newDesign !== '') {
          itemInfoList.design_type = newDesign;
        } else {
          itemInfoList.design_type = itemDesignType;
        }
      }

      // テキスト情報
      itemInfoList.text = (itemIndexList[i]).querySelector('text').textContent;
      const itemTextPosition = {
        x: parseFloat((itemIndexList[i]).querySelector('text').getAttribute('x')),
        y: parseFloat((itemIndexList[i]).querySelector('text').getAttribute('y')),
      };
      if (!Number.isNaN(itemTextPosition.x)) {
        itemInfoList.textPosition = new marietta.core.Point(itemTextPosition.x, marietta.webcad.WebCADGlobal.LAYER_SIZE_H - itemTextPosition.y);

        if (reverseBoo) {
          itemInfoList.textPosition.x *= -1;
          if (itemInfoList.text !== '' && itemInfoList.text != null) {
            // TODO: 反転の場合の処理を実装
            // //反転の場合は、テキストの幅分引く
            // var textObj = new TextField();
            // var roomTextFormat:TextFormat = new TextFormat('等幅', WebcadGlobal.SETTING_ROOM_TEXT_SIZE );
            // textObj.text = itemInfoList.room_name;
            // textObj.type = "input";
            // textObj.autoSize = "left";
            // textObj.setTextFormat(roomTextFormat);
            // itemInfoList.textPosition.x -= textObj.width;
          }
        }
        itemInfoList.text_visible = Boolean(parseInt((itemIndexList[i]).querySelector('text').getAttribute('visible'), 10));
        const areaVisible = parseInt((itemIndexList[i]).querySelector('text').getAttribute('area_visible'), 10);
        if (!Number.isNaN(areaVisible)) {
          itemInfoList.text_area_visible = Boolean(areaVisible);
        }
        const autoLayout = parseInt((itemIndexList[i]).querySelector('text').getAttribute('auto_layout'), 10);
        if (!Number.isNaN(autoLayout)) {
          itemInfoList.auto_layout = Boolean(autoLayout);
        }
        const areaUseJyou = parseInt((itemIndexList[i]).querySelector('text').getAttribute('area_use_jyou'), 10);
        if (!Number.isNaN(areaUseJyou)) {
          itemInfoList.area_use_jyou = Boolean(areaUseJyou);
        }
      }

      // ドット情報
      itemInfoList.x = 0;
      itemInfoList.y = 0;
      itemInfoList.dotList = [];
      const pointList = (itemIndexList[i]).querySelectorAll('point');
      let pointObj: marietta.webcad.collection.PointCollection;
      for (let j = 0, len2 = pointList.length; j < len2; j += 1) {
        pointObj = new marietta.webcad.collection.PointCollection();
        pointObj.x = parseInt(pointList[j].getAttribute('x'), 10);
        // TODO: 反転処理追加
        pointObj.y = marietta.webcad.WebCADGlobal.LAYER_SIZE_H - parseInt(pointList[j].getAttribute('y'), 10);
        pointObj.wall_type = parseInt(pointList[j].getAttribute('wall_type'), 10);
        pointObj.guid = pointList[j].getAttribute('guid');
        //TODO:create guid if none

        itemInfoList.dotList.push(pointObj);
      }

      itemList.push(itemInfoList);
    }

    // 順番の入れ替え
    itemList = _.sortBy(itemList, (obj) => obj.index);

    // 生成
    for (let k = 0, len3 = itemList.length; k < len3; k += 1) {
      marietta.webcad.WebCADGlobal.itemManager.createItem(itemList[k]);
    }
  }

  /**
     * 階段
     */
  static reproduceStairItem(itemXML:Element, reverseBoo: Boolean = false) {
    if (itemXML === null) { return; }

    // オブジェクト構造に変更
    const itemIndexList = itemXML.querySelectorAll('item');
    let itemList = [];
    let itemInfoList: marietta.webcad.collection.ItemInfoCollection;
    for (let i = 0, len = itemIndexList.length; i < len; i += 1) {
      itemInfoList = new marietta.webcad.collection.ItemInfoCollection();
      itemInfoList.index = parseInt(itemIndexList[i].getAttribute('index'), 10);
      itemInfoList.id = itemIndexList[i].getAttribute('id');
      itemInfoList.floor = parseInt(itemIndexList[i].getAttribute('f'), 10);
      itemInfoList.guid = itemIndexList[i].getAttribute('guid');
      //TODO:create guid if none

      itemInfoList.lr = Boolean(parseInt(itemIndexList[i].getAttribute('lr'), 10));
      itemInfoList.idthreed = itemIndexList[i].getAttribute('idthreed');
      if (itemIndexList[i].getAttribute('idthreed')) itemInfoList.idthreed = itemIndexList[i].getAttribute('idthreed');
      if (reverseBoo) itemInfoList.lr = !itemInfoList.lr;
      itemInfoList.rotation = parseInt(itemIndexList[i].getAttribute('rotation'), 10);
      if (reverseBoo) {
        if (itemInfoList.rotation === 45) itemInfoList.rotation = 315;
        if (itemInfoList.rotation === 90) itemInfoList.rotation = 270;
        if (itemInfoList.rotation === 135) itemInfoList.rotation = 225;
        if (itemInfoList.rotation === 225) itemInfoList.rotation = 135;
        if (itemInfoList.rotation === 270) itemInfoList.rotation = 90;
        if (itemInfoList.rotation === 315) itemInfoList.rotation = 45;
      }
      itemInfoList.x = Math.round(parseFloat(itemIndexList[i].getAttribute('x')));
      if (reverseBoo) itemInfoList.x *= -1;
      itemInfoList.y = marietta.webcad.WebCADGlobal.LAYER_SIZE_H - Math.round(parseFloat(itemIndexList[i].getAttribute('y')));
      itemInfoList.width = Math.abs(parseInt(itemIndexList[i].getAttribute('width'), 10));
      itemInfoList.height = Math.abs(parseInt(itemIndexList[i].getAttribute('depth'), 10));

      // ドット情報
      itemInfoList.dotList = [];
      const pointList = (itemIndexList[i]).querySelectorAll('point');
      let pointObj: marietta.webcad.collection.PointCollection;
      for (let j = 0, len2 = pointList.length; j < len2; j += 1) {
        pointObj = new marietta.webcad.collection.PointCollection();
        pointObj.x = parseInt(pointList[j].getAttribute('x'), 10);
        pointObj.y = marietta.webcad.WebCADGlobal.LAYER_SIZE_H - parseInt(pointList[j].getAttribute('y'), 10);
        pointObj.wall_type = parseInt(pointList[j].getAttribute('wall_type'), 10);
        pointObj.guid = pointList[j].getAttribute('guid');
        //TODO:create guid if none
        itemInfoList.dotList.push(pointObj);
      }

      itemList.push(itemInfoList);
    }
    // 順番の入れ替え
    itemList = _.sortBy(itemList, (obj) => obj.index);

    // 生成
    for (let k = 0, len3 = itemList.length; k < len3; k += 1) {
      marietta.webcad.WebCADGlobal.itemManager.createItem(itemList[k]);
    }
  }

  /**
     * 建具・住宅設備・家具・エクステリア
     */
  static reproduceMonicaItem(itemXML:Element, type: string, reverseBoo: Boolean = false) {
    if (itemXML === null) { return; }

    // オブジェクト構造に変更
    const itemIndexList = itemXML.querySelectorAll('item');
    let itemList = [];
    let itemInfoList: marietta.webcad.collection.ItemInfoCollection;
    for (let i = 0, len = itemIndexList.length; i < len; i += 1) {
      itemInfoList = new marietta.webcad.collection.ItemInfoCollection();
      itemInfoList.index = parseInt(itemIndexList[i].getAttribute('index'), 10);
      itemInfoList.id = itemIndexList[i].getAttribute('id');
      itemInfoList.floor = parseInt(itemIndexList[i].getAttribute('f'), 10);
      itemInfoList.guid = itemIndexList[i].getAttribute('guid');
      //TODO:create guid if none

      itemInfoList.lr = Boolean(parseInt(itemIndexList[i].getAttribute('lr'), 10));
      if (itemIndexList[i].getAttribute('idthreed')) itemInfoList.idthreed = itemIndexList[i].getAttribute('idthreed');
      if (reverseBoo) itemInfoList.lr = !itemInfoList.lr;
      itemInfoList.rotation = parseInt(itemIndexList[i].getAttribute('rotation'), 10);
      if (reverseBoo) {
        if (itemInfoList.rotation === 45) itemInfoList.rotation = 315;
        if (itemInfoList.rotation === 90) itemInfoList.rotation = 270;
        if (itemInfoList.rotation === 135) itemInfoList.rotation = 225;
        if (itemInfoList.rotation === 225) itemInfoList.rotation = 135;
        if (itemInfoList.rotation === 270) itemInfoList.rotation = 90;
        if (itemInfoList.rotation === 315) itemInfoList.rotation = 45;
      }
      if (type === 'equipment' || type === 'furniture') {
        itemInfoList.x = parseFloat(itemIndexList[i].getAttribute('x'));
        itemInfoList.y = marietta.webcad.WebCADGlobal.LAYER_SIZE_H - parseFloat(itemIndexList[i].getAttribute('y'));
      } else {
        itemInfoList.x = parseInt(itemIndexList[i].getAttribute('x'), 10);
        itemInfoList.y = marietta.webcad.WebCADGlobal.LAYER_SIZE_H - parseInt(itemIndexList[i].getAttribute('y'), 10);
      }

      if (reverseBoo) itemInfoList.x *= -1;
      itemInfoList.widthmm = Math.abs(parseInt(itemIndexList[i].getAttribute('width'), 10));
      itemInfoList.heightmm = Math.abs(parseInt(itemIndexList[i].getAttribute('depth'), 10));
      if (type === 'fitting') {
        itemInfoList.width = parseInt(itemIndexList[i].getAttribute('width'), 10);

        itemInfoList.auto_height = Boolean(parseInt(itemIndexList[i].getAttribute('auto_height'), 10));
        itemInfoList.fitting_height = parseInt(itemIndexList[i].getAttribute('height'), 10);
        itemInfoList.z = parseInt(itemIndexList[i].getAttribute('z'), 10);
        // 既存データの対応建具高さなら、自動高さに変更
        if (itemInfoList.fitting_height === 0) {
          itemInfoList.auto_height = true;
        }
      }

      itemList.push(itemInfoList);
    }
    // 順番の入れ替え
    itemList = _.sortBy(itemList, (obj) => obj.index);

    // 生成
    for (let k = 0, len3 = itemList.length; k < len3; k += 1) {
      marietta.webcad.WebCADGlobal.itemManager.createItem(itemList[k]);
    }
  }

  /**
     * 屋根
     * */
  static reproduceRoofItem(itemXML:Element) {
    if (itemXML === null) { return; }

    // オブジェクト構造に変更
    const itemIndexList = itemXML.querySelectorAll('item');
    let itemList = [];
    let itemInfoList:marietta.webcad.collection.ItemInfoCollection;
    for (let i = 0, len = itemIndexList.length; i < len; i += 1) {
      itemInfoList = new marietta.webcad.collection.ItemInfoCollection();
      itemInfoList.index = parseInt(itemIndexList[i].getAttribute('index'), 10);
      itemInfoList.id = itemIndexList[i].getAttribute('id');
      itemInfoList.floor = parseInt(itemIndexList[i].getAttribute('f'), 10);
      itemInfoList.guid = itemIndexList[i].getAttribute('guid');
      //TODO:create guid if none

      itemInfoList.x = 0;
      itemInfoList.y = 0;
      itemInfoList.roof_type = parseInt(itemIndexList[i].getAttribute('type'), 10);
      if (itemInfoList.roof_type === 2) {
        itemInfoList.roof_direction = parseInt(itemIndexList[i].getAttribute('direction_type'), 10);
      }

      const pointList = (itemIndexList[i]).querySelectorAll('point');
      let pointObj:marietta.webcad.collection.PointCollection;
      itemInfoList.dotList = [];
      for (let j = 0, len2 = pointList.length; j < len2; j += 1) {
        pointObj = new marietta.webcad.collection.PointCollection();
        pointObj.x = parseInt(pointList[j].getAttribute('x'), 10);
        pointObj.y = marietta.webcad.WebCADGlobal.LAYER_SIZE_H - parseInt(pointList[j].getAttribute('y'), 10);
        if (itemInfoList.roof_type === 1) {
          pointObj.type = parseInt(pointList[j].getAttribute('type'), 10);
        }
        pointObj.guid = pointList[j].getAttribute('guid');
        //TODO:create guid if none

        itemInfoList.dotList.push(pointObj);
      }

      itemList.push(itemInfoList);
    }
    // 順番の入れ替え
    itemList = _.sortBy(itemList, (obj) => obj.index);

    // 生成
    let hasRoof: boolean = false;
    for (let k = 0; k < itemList.length; k += 1) {
      hasRoof = true;
      marietta.webcad.WebCADGlobal.itemManager.createItem(itemList[k]);
    }

    // 屋根デザインの取得
    marietta.webcad.WebCADGlobal.itemManager.getAllRoofs();

    // 読込完了監視
    if (hasRoof) {
      marietta.webcad.util.WebcadXMLParser.roofDrawChecker = setInterval(() => marietta.webcad.util.WebcadXMLParser.roofDrawCheckInterval(), 50);
    }
  }

    static roofDrawChecker: any;

    /**
     * 屋根の描画チェック
     * @param model_paramのエレメント
     */
    static roofDrawCheckInterval(): void {
      const itemList: any[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOF_NO);
      for (let i = 0, len = itemList.length; i < len; i += 1) {
        if (!(itemList[i] as marietta.webcad.item.Roof).hasDrawing()) {
          return;
        }
      }
      clearInterval(marietta.webcad.util.WebcadXMLParser.roofDrawChecker);

      // 中央表示を再度実施する
      marietta.webcad.WebCADGlobal.scrollerManager.controlLayerEnlargementFit();
    }

    /**
     * model_Paramのパース
     * @param model_paramのエレメント
     */
    static parseModelParam(paramNode: Element): void {
      // 2Dのマネージャで保持
      const optionNode = (paramNode).querySelector('option') ? (paramNode).querySelector('option') : null;
      const heightNode = (paramNode).querySelector('height') ? (paramNode).querySelector('height') : null;
      const autoNode: any = (paramNode).querySelector('auto') ? (paramNode).querySelector('auto') : null;
      const materialNode = (paramNode).querySelector('material') ? (paramNode).querySelector('material') : null;
      let modelParam;
      if (heightNode || autoNode || materialNode) {
        marietta.webcad.WebCADGlobal.autoMain.perseModelHeightXML(heightNode);
        marietta.webcad.WebCADGlobal.autoMain.perseModelAutoXML(autoNode);
        modelParam = new marietta.webcad.collection.ModelParamCollection(optionNode, heightNode, autoNode, materialNode);
        marietta.webcad.WebCADGlobal.webcad2Dmanager.modelParam = modelParam;
      }
    }

    /**
     * 保持している下絵があれば、再生成
     */
    static resetShitae(): void {
      if (!marietta.webcad.WebCADGlobal.webcad2Dmanager.shitaeList || marietta.webcad.WebCADGlobal.webcad2Dmanager.shitaeList.length === 0) return;

      for (let i = 1; i <= marietta.webcad.WebCADGlobal.webcad2Dmanager.shitaeInfoList.length; i += 1) {
        const currentFloor: marietta.webcad.layer.FloorShitaeLayer = (marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(i, true) as marietta.webcad.layer.FloorShitaeLayer);
        // console.log(marietta.webcad.WebCADGlobal.webcad2Dmanager.shitaeList[i-1]);
        currentFloor.layer_shitae.defaultItemInfo = Object.assign(currentFloor.layer_shitae.defaultItemInfo, marietta.webcad.WebCADGlobal.webcad2Dmanager.shitaeInfoList[i - 1]);
        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.shitaeList[i - 1]) {
          currentFloor.layer_shitae.childList.push(marietta.webcad.WebCADGlobal.webcad2Dmanager.shitaeList[i - 1]);
          (currentFloor.layer_shitae.spt.element).append(marietta.webcad.WebCADGlobal.webcad2Dmanager.shitaeList[i - 1].spt.element);
        }
      }
    }
}
export default WebcadXMLParser;
